import { all } from 'redux-saga/effects'
import { forgotPasswordSaga } from './forgotPassword/saga'
import { loginSaga } from './login/saga'
import { logoutSaga } from './logout/saga'
import { registerSaga } from './register/saga'
import { resetPasswordSaga } from './resetPassword/saga'
import { verifyEmailSaga } from './verifyEmail/saga'

export function* authSaga() {
  yield all([
    registerSaga(),
    loginSaga(),
    verifyEmailSaga(),
    forgotPasswordSaga(),
    logoutSaga(),
    resetPasswordSaga(),
  ])
}
